import { Switch } from "@/components/ui/switch";

export const DailyReportSwitch = ({ checked, onChange, testid }) => (
  <label className="flex items-start justify-between gap-4 rounded-xl border bg-slate-50 p-3 sm:col-span-2">
    <span>
      <span className="block text-sm font-medium">Rapporto di fine giornata</span>
      <span className="block text-xs text-slate-500">{checked
        ? "Ogni giorno il responsabile scrive il lavoro svolto: riceve il promemoria dopo l'uscita e, se manca, l'admin viene avvisato."
        : "Nessun rapportino giornaliero né promemoria: i giorni si segnano come svolti e resta solo il rapporto finale."}</span>
    </span>
    <Switch checked={checked} onCheckedChange={onChange} data-testid={testid} />
  </label>
);
